import { ComponentProps, useState } from 'react';

import classNames from 'classnames';

import { IconImage } from '@spotify-internal/encore-web';
import { Image } from '@spotify-internal/encore-web/next';

import { Lightbox } from './Lightbox';

import styles from './PreviewableImage.module.css';

export type PreviewableImageProps = Omit<
  ComponentProps<typeof Image>,
  'src' | 'alt'
> & {
  src?: string;
  alt?: string;
};

export const PreviewableImage = ({
  src,
  alt,
  className,
  placeholderIcon = IconImage,
  imageProps,
  width,
  height,
  aspectRatio,
  borderRadius,
  placeholderBackgroundColor,
  ...rest
}: PreviewableImageProps) => {
  const [previewOriginRect, setPreviewOriginRect] = useState<DOMRect | null>(
    null,
  );
  const baseProps = {
    width,
    height,
    aspectRatio,
    borderRadius,
    placeholderBackgroundColor,
  };

  if (!src) {
    return (
      <Image
        placeholderIcon={placeholderIcon}
        className={className}
        {...baseProps}
      />
    );
  }

  return (
    <>
      <button
        type="button"
        className={classNames(styles.button, className)}
        onClick={e =>
          setPreviewOriginRect(e.currentTarget.getBoundingClientRect())
        }
        aria-label={alt ? `Enlarge ${alt} image` : 'Enlarge image'}
      >
        <Image
          src={src}
          alt={alt ?? ''}
          imageProps={imageProps}
          {...baseProps}
          {...rest}
        />
      </button>
      {previewOriginRect && (
        <Lightbox
          src={src}
          alt={alt}
          originRect={previewOriginRect}
          onClose={() => setPreviewOriginRect(null)}
        />
      )}
    </>
  );
};
